export const DEFAULT_THEME = 'dark';

export const EXPORT_TARGETS = [
  {
    label: '.PNG',
    value: 'png',
  },
  {
    label: '.PNG (2x)',
    value: 'png@2x',
  },
  {
    label: '.PDF',
    value: 'pdf',
  },
  {
    label: '.CSV',
    value: 'csv',
  },
] as const;
